module.exports = __webpack_public_path__ + "img/download-android@2x.cc93dc81.png";